// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___PYzH","label":"styles_label__38LRQ"};